<template lang="pug">
.mg-game__money
  .mg-game__money__inner
    .label {{ getLabelText }}
    .count {{ getBalance }}
    img(:src="getBackgroundImage")
      
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";

const mg_global = getStoreModuleByName("global");
const { mapGetters } = createNamespacedHelpers(mg_global);

export default {
  name: "GameMoney",

  computed: {
    ...mapGetters(["getBalance", "getActivityType"]),

    getLabelText() {
      return this.$t(`game.money.${this.getActivityType}`);
    },

    getBackgroundImage() {
      return require("@/assets/game/images/money_bg.svg");
    },
  },
};
</script>
